var _circle, _line, _rect, _rect2, _rect3, _path, _line2, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#B05FFD",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#7B2CBF",
      stopOpacity: 1
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 80,
    fill: "none",
    stroke: "url(#grad1)",
    strokeWidth: 20
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 260,
    x2: 320,
    y2: 320,
    stroke: "url(#grad1)",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 280,
    width: 40,
    height: 120,
    rx: 5,
    fill: "#e0e0e0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 220,
    width: 40,
    height: 180,
    rx: 5,
    fill: "#c0c0c0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 160,
    width: 40,
    height: 240,
    rx: 5,
    fill: "url(#grad1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340 150 L400 90 L460 150",
    fill: "none",
    stroke: "url(#grad1)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 90,
    x2: 400,
    y2: 180,
    stroke: "url(#grad1)",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 320,
    width: 100,
    height: 35,
    rx: 17,
    fill: "#f0f0f0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 370,
    width: 80,
    height: 35,
    rx: 17,
    fill: "url(#grad1)",
    opacity: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 370,
    width: 90,
    height: 35,
    rx: 17,
    fill: "#f0f0f0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.5d6872d6b0c110e9fe7a913c7ed327fa.svg";
export { ForwardRef as ReactComponent };